/**
 * Lista de 349 comunas SII con código Tesorería
 */
export const COMUNAS_SII = [
    { codigo: 1, nombre: 'ARICA' },
    { codigo: 2, nombre: 'IQUIQUE' },
    { codigo: 3, nombre: 'HUARA' },
    { codigo: 4, nombre: 'PICA' },
    { codigo: 5, nombre: 'POZO ALMONTE' },
    { codigo: 6, nombre: 'TOCOPILLA' },
    { codigo: 7, nombre: 'ANTOFAGASTA' },
    { codigo: 8, nombre: 'MEJILLONES' },
    { codigo: 9, nombre: 'TALTAL' },
    { codigo: 10, nombre: 'CALAMA' },
    { codigo: 11, nombre: 'CHANARAL' },
    { codigo: 12, nombre: 'DIEGO DE ALMAGRO' },
    { codigo: 13, nombre: 'COPIAPO' },
    { codigo: 14, nombre: 'CALDERA' },
    { codigo: 15, nombre: 'TIERRA AMARILLA' },
    { codigo: 16, nombre: 'VALLENAR' },
    { codigo: 17, nombre: 'FREIRINA' },
    { codigo: 18, nombre: 'HUASCO' },
    { codigo: 19, nombre: 'LA SERENA' },
    { codigo: 20, nombre: 'LA HIGUERA' },
    { codigo: 21, nombre: 'COQUIMBO' },
    { codigo: 22, nombre: 'ANDACOLLO' },
    { codigo: 23, nombre: 'VICUNA' },
    { codigo: 24, nombre: 'PAIHUANO' },
    { codigo: 25, nombre: 'OVALLE' },
    { codigo: 26, nombre: 'MONTE PATRIA' },
    { codigo: 27, nombre: 'PUNITAQUI' },
    { codigo: 28, nombre: 'RIO HURTADO' },
    { codigo: 29, nombre: 'COMBARBALA' },
    { codigo: 30, nombre: 'ILLAPEL' },
    { codigo: 31, nombre: 'CANELA' },
    { codigo: 32, nombre: 'SALAMANCA' },
    { codigo: 33, nombre: 'LOS VILOS' },
    { codigo: 34, nombre: 'VALPARAISO' },
    { codigo: 35, nombre: 'QUINTERO' },
    { codigo: 36, nombre: 'PUCHUNCAVI' },
    { codigo: 37, nombre: 'VINA DEL MAR' },
    { codigo: 38, nombre: 'QUILPUE' },
    { codigo: 39, nombre: 'VILLA ALEMANA' },
    { codigo: 40, nombre: 'CASABLANCA' },
    { codigo: 41, nombre: 'ISLA DE PASCUA' },
    { codigo: 42, nombre: 'SAN ANTONIO' },
    { codigo: 43, nombre: 'SANTO DOMINGO' },
    { codigo: 44, nombre: 'ALGARROBO' },
    { codigo: 45, nombre: 'EL QUISCO' },
    { codigo: 46, nombre: 'CARTAGENA' },
    { codigo: 47, nombre: 'EL TABO' },
    { codigo: 48, nombre: 'QUILLOTA' },
    { codigo: 49, nombre: 'LA CRUZ' },
    { codigo: 50, nombre: 'LA CALERA' },
    { codigo: 51, nombre: 'HIJUELAS' },
    { codigo: 52, nombre: 'NOGALES' },
    { codigo: 53, nombre: 'LIMACHE' },
    { codigo: 54, nombre: 'OLMUE' },
    { codigo: 55, nombre: 'PETORCA' },
    { codigo: 56, nombre: 'CABILDO' },
    { codigo: 57, nombre: 'PAPUDO' },
    { codigo: 58, nombre: 'ZAPALLAR' },
    { codigo: 59, nombre: 'LA LIGUA' },
    { codigo: 60, nombre: 'SAN FELIPE' },
    { codigo: 61, nombre: 'PUTAENDO' },
    { codigo: 62, nombre: 'PANQUEHUE' },
    { codigo: 63, nombre: 'CATEMU' },
    { codigo: 64, nombre: 'SANTA MARIA' },
    { codigo: 65, nombre: 'LLAY-LLAY' },
    { codigo: 66, nombre: 'LOS ANDES' },
    { codigo: 67, nombre: 'CALLE LARGA' },
    { codigo: 68, nombre: 'RINCONADA' },
    { codigo: 69, nombre: 'SAN ESTEBAN' },
    { codigo: 70, nombre: 'SANTIAGO' },
    { codigo: 71, nombre: 'LAS CONDES' },
    { codigo: 72, nombre: 'PROVIDENCIA' },
    { codigo: 73, nombre: 'SANTIAGO OESTE' },
    { codigo: 75, nombre: 'CONCHALI' },
    { codigo: 76, nombre: 'COLINA' },
    { codigo: 77, nombre: 'RENCA' },
    { codigo: 78, nombre: 'LAMPA' },
    { codigo: 79, nombre: 'QUILICURA' },
    { codigo: 80, nombre: 'TIL-TIL' },
    { codigo: 81, nombre: 'QUINTA NORMAL' },
    { codigo: 82, nombre: 'PUDAHUEL' },
    { codigo: 83, nombre: 'CURACAVI' },
    { codigo: 84, nombre: 'SANTIAGO SUR' },
    { codigo: 85, nombre: 'PENAFLOR' },
    { codigo: 86, nombre: 'TALAGANTE' },
    { codigo: 87, nombre: 'ISLA DE MAIPO' },
    { codigo: 88, nombre: 'MELIPILLA' },
    { codigo: 89, nombre: 'EL MONTE' },
    { codigo: 90, nombre: 'MARIA PINTO' },
    { codigo: 91, nombre: 'NUNOA' },
    { codigo: 92, nombre: 'LA REINA' },
    { codigo: 93, nombre: 'LA FLORIDA' },
    { codigo: 94, nombre: 'MAIPU' },
    { codigo: 95, nombre: 'SAN MIGUEL' },
    { codigo: 96, nombre: 'LA CISTERNA' },
    { codigo: 97, nombre: 'LA GRANJA' },
    { codigo: 98, nombre: 'SAN BERNARDO' },
    { codigo: 99, nombre: 'CALERA DE TANGO' },
    { codigo: 100, nombre: 'PUENTE ALTO' },
    { codigo: 101, nombre: 'PIRQUE' },
    { codigo: 102, nombre: 'SAN JOSE DE MAIPO' },
    { codigo: 103, nombre: 'BUIN' },
    { codigo: 104, nombre: 'PAINE' },
    { codigo: 105, nombre: 'RANCAGUA' },
    { codigo: 106, nombre: 'MACHALI' },
    { codigo: 107, nombre: 'GRANEROS' },
    { codigo: 108, nombre: 'SAN PEDRO' },
    { codigo: 109, nombre: 'ALHUE' },
    { codigo: 110, nombre: 'CODEGUA' },
    { codigo: 111, nombre: 'SAN FRANCISCO DE MOSTAZAL' },
    { codigo: 112, nombre: 'DONIHUE' },
    { codigo: 113, nombre: 'COLTAUCO' },
    { codigo: 114, nombre: 'COINCO' },
    { codigo: 115, nombre: 'PEUMO' },
    { codigo: 116, nombre: 'LAS CABRAS' },
    { codigo: 117, nombre: 'SAN VICENTE' },
    { codigo: 118, nombre: 'PICHIDEGUA' },
    { codigo: 119, nombre: 'REQUINOA' },
    { codigo: 120, nombre: 'OLIVAR' },
    { codigo: 121, nombre: 'RENGO' },
    { codigo: 122, nombre: 'MALLOA' },
    { codigo: 123, nombre: 'QUINTA DE TILCOCO' },
    { codigo: 124, nombre: 'SAN FERNANDO' },
    { codigo: 125, nombre: 'CHIMBARONGO' },
    { codigo: 126, nombre: 'NANCAGUA' },
    { codigo: 127, nombre: 'PLACILLA' },
    { codigo: 128, nombre: 'SANTA CRUZ' },
    { codigo: 129, nombre: 'LOLOL' },
    { codigo: 130, nombre: 'PALMILLA' },
    { codigo: 131, nombre: 'PERALILLO' },
    { codigo: 132, nombre: 'CHEPICA' },
    { codigo: 133, nombre: 'PAREDONES' },
    { codigo: 134, nombre: 'MARCHIGUE' },
    { codigo: 135, nombre: 'PUMANQUE' },
    { codigo: 136, nombre: 'LITUECHE' },
    { codigo: 137, nombre: 'PICHILEMU' },
    { codigo: 138, nombre: 'NAVIDAD' },
    { codigo: 139, nombre: 'LA ESTRELLA' },
    { codigo: 140, nombre: 'CURICO' },
    { codigo: 141, nombre: 'ROMERAL' },
    { codigo: 142, nombre: 'TENO' },
    { codigo: 143, nombre: 'RAUCO' },
    { codigo: 144, nombre: 'HUALANE' },
    { codigo: 145, nombre: 'LICANTEN' },
    { codigo: 146, nombre: 'VICHUQUEN' },
    { codigo: 147, nombre: 'MOLINA' },
    { codigo: 148, nombre: 'SAGRADA FAMILIA' },
    { codigo: 149, nombre: 'RIO CLARO' },
    { codigo: 150, nombre: 'TALCA' },
    { codigo: 151, nombre: 'SAN CLEMENTE' },
    { codigo: 152, nombre: 'PELARCO' },
    { codigo: 153, nombre: 'PENCAHUE' },
    { codigo: 154, nombre: 'MAULE' },
    { codigo: 155, nombre: 'CUREPTO' },
    { codigo: 156, nombre: 'SAN JAVIER' },
    { codigo: 157, nombre: 'CONSTITUCION' },
    { codigo: 158, nombre: 'EMPEDRADO' },
    { codigo: 159, nombre: 'LINARES' },
    { codigo: 160, nombre: 'YERBAS BUENAS' },
    { codigo: 161, nombre: 'COLBUN' },
    { codigo: 162, nombre: 'LONGAVI' },
    { codigo: 163, nombre: 'VILLA ALEGRE' },
    { codigo: 164, nombre: 'PARRAL' },
    { codigo: 165, nombre: 'RETIRO' },
    { codigo: 166, nombre: 'CAUQUENES' },
    { codigo: 167, nombre: 'CHANCO' },
    { codigo: 168, nombre: 'CHILLAN' },
    { codigo: 169, nombre: 'PINTO' },
    { codigo: 170, nombre: 'COIHUECO' },
    { codigo: 171, nombre: 'PORTEZUELO' },
    { codigo: 172, nombre: 'QUIRIHUE' },
    { codigo: 173, nombre: 'TREHUACO' },
    { codigo: 174, nombre: 'NINHUE' },
    { codigo: 175, nombre: 'COBQUECURA' },
    { codigo: 176, nombre: 'SAN CARLOS' },
    { codigo: 177, nombre: 'NIQUEN' },
    { codigo: 178, nombre: 'SAN FABIAN' },
    { codigo: 179, nombre: 'SAN NICOLAS' },
    { codigo: 180, nombre: 'BULNES' },
    { codigo: 181, nombre: 'SAN IGNACIO' },
    { codigo: 182, nombre: 'QUILLON' },
    { codigo: 183, nombre: 'YUNGAY' },
    { codigo: 184, nombre: 'PEMUCO' },
    { codigo: 185, nombre: 'EL CARMEN' },
    { codigo: 186, nombre: 'COELEMU' },
    { codigo: 187, nombre: 'RANQUIL' },
    { codigo: 188, nombre: 'CONCEPCION' },
    { codigo: 189, nombre: 'TALCAHUANO' },
    { codigo: 190, nombre: 'TOME' },
    { codigo: 191, nombre: 'PENCO' },
    { codigo: 192, nombre: 'HUALQUI' },
    { codigo: 193, nombre: 'FLORIDA' },
    { codigo: 194, nombre: 'CORONEL' },
    { codigo: 195, nombre: 'LOTA' },
    { codigo: 196, nombre: 'SANTA JUANA' },
    { codigo: 197, nombre: 'CURANILAHUE' },
    { codigo: 198, nombre: 'ARAUCO' },
    { codigo: 199, nombre: 'LEBU' },
    { codigo: 200, nombre: 'LOS ALAMOS' },
    { codigo: 201, nombre: 'CANETE' },
    { codigo: 202, nombre: 'CONTULMO' },
    { codigo: 203, nombre: 'TIRUA' },
    { codigo: 204, nombre: 'LOS ANGELES' },
    { codigo: 205, nombre: 'SANTA BARBARA' },
    { codigo: 206, nombre: 'QUILLECO' },
    { codigo: 207, nombre: 'YUMBEL' },
    { codigo: 208, nombre: 'CABRERO' },
    { codigo: 209, nombre: 'TUCAPEL' },
    { codigo: 210, nombre: 'LAJA' },
    { codigo: 211, nombre: 'SAN ROSENDO' },
    { codigo: 212, nombre: 'NACIMIENTO' },
    { codigo: 213, nombre: 'NEGRETE' },
    { codigo: 214, nombre: 'MULCHEN' },
    { codigo: 215, nombre: 'QUILACO' },
    { codigo: 216, nombre: 'ANGOL' },
    { codigo: 217, nombre: 'PUREN' },
    { codigo: 218, nombre: 'LOS SAUCES' },
    { codigo: 219, nombre: 'RENAICO' },
    { codigo: 220, nombre: 'COLLIPULLI' },
    { codigo: 221, nombre: 'ERCILLA' },
    { codigo: 222, nombre: 'TRAIGUEN' },
    { codigo: 223, nombre: 'LUMACO' },
    { codigo: 224, nombre: 'VICTORIA' },
    { codigo: 225, nombre: 'CURACAUTIN' },
    { codigo: 226, nombre: 'LONQUIMAY' },
    { codigo: 227, nombre: 'TEMUCO' },
    { codigo: 228, nombre: 'VILCUN' },
    { codigo: 229, nombre: 'FREIRE' },
    { codigo: 230, nombre: 'CUNCO' },
    { codigo: 231, nombre: 'LAUTARO' },
    { codigo: 232, nombre: 'GALVARINO' },
    { codigo: 233, nombre: 'PERQUENCO' },
    { codigo: 234, nombre: 'NUEVA IMPERIAL' },
    { codigo: 235, nombre: 'CARAHUE' },
    { codigo: 236, nombre: 'SAAVEDRA' },
    { codigo: 237, nombre: 'PITRUFQUEN' },
    { codigo: 238, nombre: 'GORBEA' },
    { codigo: 239, nombre: 'TOLTEN' },
    { codigo: 240, nombre: 'LONCOCHE' },
    { codigo: 241, nombre: 'VILLARRICA' },
    { codigo: 242, nombre: 'PUCON' },
    { codigo: 243, nombre: 'VALDIVIA' },
    { codigo: 244, nombre: 'CORRAL' },
    { codigo: 245, nombre: 'MARIQUINA' },
    { codigo: 246, nombre: 'MAFIL' },
    { codigo: 247, nombre: 'LOS LAGOS' },
    { codigo: 248, nombre: 'FUTRONO' },
    { codigo: 249, nombre: 'LANCO' },
    { codigo: 250, nombre: 'PANGUIPULLI' },
    { codigo: 251, nombre: 'LA UNION' },
    { codigo: 252, nombre: 'PAILLACO' },
    { codigo: 253, nombre: 'RIO BUENO' },
    { codigo: 254, nombre: 'LAGO RANCO' },
    { codigo: 255, nombre: 'OSORNO' },
    { codigo: 256, nombre: 'PUYEHUE' },
    { codigo: 257, nombre: 'SAN PABLO' },
    { codigo: 258, nombre: 'PUERTO OCTAY' },
    { codigo: 259, nombre: 'RIO NEGRO' },
    { codigo: 260, nombre: 'PURRANQUE' },
    { codigo: 261, nombre: 'PUERTO MONTT' },
    { codigo: 262, nombre: 'COCHAMO' },
    { codigo: 263, nombre: 'MAULLIN' },
    { codigo: 264, nombre: 'LOS MUERMOS' },
    { codigo: 265, nombre: 'CALBUCO' },
    { codigo: 266, nombre: 'PUERTO VARAS' },
    { codigo: 267, nombre: 'LLANQUIHUE' },
    { codigo: 268, nombre: 'FRESIA' },
    { codigo: 269, nombre: 'FRUTILLAR' },
    { codigo: 270, nombre: 'CASTRO' },
    { codigo: 271, nombre: 'CHONCHI' },
    { codigo: 272, nombre: 'QUEILEN' },
    { codigo: 273, nombre: 'QUELLON' },
    { codigo: 274, nombre: 'PUQUELDON' },
    { codigo: 275, nombre: 'QUINCHAO' },
    { codigo: 276, nombre: 'CURACO DE VELEZ' },
    { codigo: 277, nombre: 'ANCUD' },
    { codigo: 278, nombre: 'QUEMCHI' },
    { codigo: 279, nombre: 'DALCAHUE' },
    { codigo: 280, nombre: 'CHAITEN' },
    { codigo: 281, nombre: 'FUTALEUFU' },
    { codigo: 282, nombre: 'PALENA' },
    { codigo: 284, nombre: 'COYHAIQUE' },
    { codigo: 285, nombre: 'AYSEN' },
    { codigo: 286, nombre: 'CISNES' },
    { codigo: 287, nombre: 'CHILE CHICO' },
    { codigo: 288, nombre: 'RIO IBANEZ' },
    { codigo: 289, nombre: 'COCHRANE' },
    { codigo: 290, nombre: 'PUNTA ARENAS' },
    { codigo: 291, nombre: 'NATALES' },
    { codigo: 292, nombre: 'PORVENIR' },
    { codigo: 293, nombre: 'GENERAL LAGOS' },
    { codigo: 294, nombre: 'PUTRE' },
    { codigo: 295, nombre: 'CAMARONES' },
    { codigo: 296, nombre: 'CAMINA' },
    { codigo: 297, nombre: 'COLCHANE' },
    { codigo: 298, nombre: 'MARIA ELENA' },
    { codigo: 299, nombre: 'SIERRA GORDA' },
    { codigo: 300, nombre: 'OLLAGUE' },
    { codigo: 301, nombre: 'SAN PEDRO DE ATACAMA' },
    { codigo: 302, nombre: 'ALTO DEL CARMEN' },
    { codigo: 303, nombre: 'ANTUCO' },
    { codigo: 304, nombre: 'MELIPEUCO' },
    { codigo: 305, nombre: 'CURARREHUE' },
    { codigo: 306, nombre: 'TEODORO SCHMIDT' },
    { codigo: 307, nombre: 'SAN JUAN DE LA COSTA' },
    { codigo: 308, nombre: 'HUALAIHUE' },
    { codigo: 309, nombre: 'GUAITECAS' },
    { codigo: 310, nombre: 'OHIGGINS' },
    { codigo: 311, nombre: 'TORTEL' },
    { codigo: 312, nombre: 'LAGO VERDE' },
    { codigo: 313, nombre: 'TORRES DEL PAINE' },
    { codigo: 314, nombre: 'RIO VERDE' },
    { codigo: 315, nombre: 'SAN GREGORIO' },
    { codigo: 316, nombre: 'LAGUNA BLANCA' },
    { codigo: 317, nombre: 'PRIMAVERA' },
    { codigo: 318, nombre: 'TIMAUKEL' },
    { codigo: 319, nombre: 'CABO DE HORNOS' },
    { codigo: 320, nombre: 'PELLUHUE' },
    { codigo: 321, nombre: 'JUAN FERNANDEZ' },
    { codigo: 322, nombre: 'PENALOLEN' },
    { codigo: 323, nombre: 'MACUL' },
    { codigo: 324, nombre: 'CERRO NAVIA' },
    { codigo: 325, nombre: 'LO PRADO' },
    { codigo: 326, nombre: 'SAN RAMON' },
    { codigo: 327, nombre: 'LA PINTANA' },
    { codigo: 328, nombre: 'ESTACION CENTRAL' },
    { codigo: 329, nombre: 'RECOLETA' },
    { codigo: 330, nombre: 'INDEPENDENCIA' },
    { codigo: 331, nombre: 'VITACURA' },
    { codigo: 332, nombre: 'LO BARNECHEA' },
    { codigo: 333, nombre: 'CERRILLOS' },
    { codigo: 334, nombre: 'HUECHURABA' },
    { codigo: 335, nombre: 'SAN JOAQUIN' },
    { codigo: 336, nombre: 'PEDRO AGUIRRE CERDA' },
    { codigo: 337, nombre: 'LO ESPEJO' },
    { codigo: 338, nombre: 'EL BOSQUE' },
    { codigo: 339, nombre: 'PADRE HURTADO' },
    { codigo: 340, nombre: 'CONCON' },
    { codigo: 341, nombre: 'SAN RAFAEL' },
    { codigo: 342, nombre: 'CHILLAN VIEJO' },
    { codigo: 343, nombre: 'SAN PEDRO DE LA PAZ' },
    { codigo: 344, nombre: 'CHIGUAYANTE' },
    { codigo: 345, nombre: 'PADRE LAS CASAS' },
    { codigo: 346, nombre: 'HUALPEN' },
    { codigo: 347, nombre: 'ALTO HOSPICIO' },
    { codigo: 348, nombre: 'CHOLCHOL' },
    { codigo: 349, nombre: 'ALTO BIOBIO' }
];

/**
 * Mapeo de código de comuna → nombre de región
 */
export const REGION_BY_CODIGO = {
    1: 'Arica y Parinacota',
    2: 'Tarapacá', 3: 'Tarapacá', 4: 'Tarapacá', 5: 'Tarapacá',
    6: 'Antofagasta', 7: 'Antofagasta', 8: 'Antofagasta', 9: 'Antofagasta', 10: 'Antofagasta',
    11: 'Atacama', 12: 'Atacama', 13: 'Atacama', 14: 'Atacama', 15: 'Atacama',
    16: 'Atacama', 17: 'Atacama', 18: 'Atacama',
    19: 'Coquimbo', 20: 'Coquimbo', 21: 'Coquimbo', 22: 'Coquimbo', 23: 'Coquimbo',
    24: 'Coquimbo', 25: 'Coquimbo', 26: 'Coquimbo', 27: 'Coquimbo', 28: 'Coquimbo',
    29: 'Coquimbo', 30: 'Coquimbo', 31: 'Coquimbo', 32: 'Coquimbo', 33: 'Coquimbo',
    34: 'Valparaíso', 35: 'Valparaíso', 36: 'Valparaíso', 37: 'Valparaíso', 38: 'Valparaíso',
    39: 'Valparaíso', 40: 'Valparaíso', 41: 'Valparaíso', 42: 'Valparaíso', 43: 'Valparaíso',
    44: 'Valparaíso', 45: 'Valparaíso', 46: 'Valparaíso', 47: 'Valparaíso', 48: 'Valparaíso',
    49: 'Valparaíso', 50: 'Valparaíso', 51: 'Valparaíso', 52: 'Valparaíso', 53: 'Valparaíso',
    54: 'Valparaíso', 55: 'Valparaíso', 56: 'Valparaíso', 57: 'Valparaíso', 58: 'Valparaíso',
    59: 'Valparaíso', 60: 'Valparaíso', 61: 'Valparaíso', 62: 'Valparaíso', 63: 'Valparaíso',
    64: 'Valparaíso', 65: 'Valparaíso', 66: 'Valparaíso', 67: 'Valparaíso', 68: 'Valparaíso',
    69: 'Valparaíso', 321: 'Valparaíso', 340: 'Valparaíso',
    70: 'Metropolitana', 71: 'Metropolitana', 72: 'Metropolitana', 73: 'Metropolitana',
    75: 'Metropolitana', 76: 'Metropolitana', 77: 'Metropolitana', 78: 'Metropolitana',
    79: 'Metropolitana', 80: 'Metropolitana', 81: 'Metropolitana', 82: 'Metropolitana',
    83: 'Metropolitana', 84: 'Metropolitana', 85: 'Metropolitana', 86: 'Metropolitana',
    87: 'Metropolitana', 88: 'Metropolitana', 89: 'Metropolitana', 90: 'Metropolitana',
    91: 'Metropolitana', 92: 'Metropolitana', 93: 'Metropolitana', 94: 'Metropolitana',
    95: 'Metropolitana', 96: 'Metropolitana', 97: 'Metropolitana', 98: 'Metropolitana',
    99: 'Metropolitana', 100: 'Metropolitana', 101: 'Metropolitana', 102: 'Metropolitana',
    103: 'Metropolitana', 104: 'Metropolitana', 322: 'Metropolitana', 323: 'Metropolitana',
    324: 'Metropolitana', 325: 'Metropolitana', 326: 'Metropolitana', 327: 'Metropolitana',
    328: 'Metropolitana', 329: 'Metropolitana', 330: 'Metropolitana', 331: 'Metropolitana',
    332: 'Metropolitana', 333: 'Metropolitana', 334: 'Metropolitana', 335: 'Metropolitana',
    336: 'Metropolitana', 337: 'Metropolitana', 338: 'Metropolitana', 339: 'Metropolitana',
    105: "O'Higgins", 106: "O'Higgins", 107: "O'Higgins", 108: "O'Higgins", 109: "O'Higgins",
    110: "O'Higgins", 111: "O'Higgins", 112: "O'Higgins", 113: "O'Higgins", 114: "O'Higgins",
    115: "O'Higgins", 116: "O'Higgins", 117: "O'Higgins", 118: "O'Higgins", 119: "O'Higgins",
    120: "O'Higgins", 121: "O'Higgins", 122: "O'Higgins", 123: "O'Higgins", 124: "O'Higgins",
    125: "O'Higgins", 126: "O'Higgins", 127: "O'Higgins", 128: "O'Higgins", 129: "O'Higgins",
    130: "O'Higgins", 131: "O'Higgins", 132: "O'Higgins", 133: "O'Higgins", 134: "O'Higgins",
    135: "O'Higgins", 136: "O'Higgins", 137: "O'Higgins", 138: "O'Higgins", 139: "O'Higgins",
    140: 'Maule', 141: 'Maule', 142: 'Maule', 143: 'Maule', 144: 'Maule',
    145: 'Maule', 146: 'Maule', 147: 'Maule', 148: 'Maule', 149: 'Maule',
    150: 'Maule', 151: 'Maule', 152: 'Maule', 153: 'Maule', 154: 'Maule',
    155: 'Maule', 156: 'Maule', 157: 'Maule', 158: 'Maule', 159: 'Maule',
    160: 'Maule', 161: 'Maule', 162: 'Maule', 163: 'Maule', 164: 'Maule',
    165: 'Maule', 166: 'Maule', 167: 'Maule', 320: 'Maule', 341: 'Maule',
    168: 'Ñuble', 169: 'Ñuble', 170: 'Ñuble', 171: 'Ñuble', 172: 'Ñuble',
    173: 'Ñuble', 174: 'Ñuble', 175: 'Ñuble', 176: 'Ñuble', 177: 'Ñuble',
    178: 'Ñuble', 179: 'Ñuble', 180: 'Ñuble', 181: 'Ñuble', 182: 'Ñuble',
    183: 'Ñuble', 184: 'Ñuble', 185: 'Ñuble', 186: 'Ñuble', 187: 'Ñuble', 342: 'Ñuble',
    188: 'Biobío', 189: 'Biobío', 190: 'Biobío', 191: 'Biobío', 192: 'Biobío',
    193: 'Biobío', 194: 'Biobío', 195: 'Biobío', 196: 'Biobío', 197: 'Biobío',
    198: 'Biobío', 199: 'Biobío', 200: 'Biobío', 201: 'Biobío', 202: 'Biobío',
    203: 'Biobío', 204: 'Biobío', 205: 'Biobío', 206: 'Biobío', 207: 'Biobío',
    208: 'Biobío', 209: 'Biobío', 210: 'Biobío', 211: 'Biobío', 212: 'Biobío',
    213: 'Biobío', 214: 'Biobío', 215: 'Biobío', 303: 'Biobío', 343: 'Biobío',
    344: 'Biobío', 346: 'Biobío', 349: 'Biobío',
    216: 'La Araucanía', 217: 'La Araucanía', 218: 'La Araucanía', 219: 'La Araucanía',
    220: 'La Araucanía', 221: 'La Araucanía', 222: 'La Araucanía', 223: 'La Araucanía',
    224: 'La Araucanía', 225: 'La Araucanía', 226: 'La Araucanía', 227: 'La Araucanía',
    228: 'La Araucanía', 229: 'La Araucanía', 230: 'La Araucanía', 231: 'La Araucanía',
    232: 'La Araucanía', 233: 'La Araucanía', 234: 'La Araucanía', 235: 'La Araucanía',
    236: 'La Araucanía', 237: 'La Araucanía', 238: 'La Araucanía', 239: 'La Araucanía',
    240: 'La Araucanía', 241: 'La Araucanía', 242: 'La Araucanía', 304: 'La Araucanía',
    305: 'La Araucanía', 306: 'La Araucanía', 345: 'La Araucanía', 348: 'La Araucanía',
    243: 'Los Ríos', 244: 'Los Ríos', 245: 'Los Ríos', 246: 'Los Ríos', 247: 'Los Ríos',
    248: 'Los Ríos', 249: 'Los Ríos', 250: 'Los Ríos', 251: 'Los Ríos', 252: 'Los Ríos',
    253: 'Los Ríos', 254: 'Los Ríos',
    255: 'Los Lagos', 256: 'Los Lagos', 257: 'Los Lagos', 258: 'Los Lagos', 259: 'Los Lagos',
    260: 'Los Lagos', 261: 'Los Lagos', 262: 'Los Lagos', 263: 'Los Lagos', 264: 'Los Lagos',
    265: 'Los Lagos', 266: 'Los Lagos', 267: 'Los Lagos', 268: 'Los Lagos', 269: 'Los Lagos',
    270: 'Los Lagos', 271: 'Los Lagos', 272: 'Los Lagos', 273: 'Los Lagos', 274: 'Los Lagos',
    275: 'Los Lagos', 276: 'Los Lagos', 277: 'Los Lagos', 278: 'Los Lagos', 279: 'Los Lagos',
    280: 'Los Lagos', 281: 'Los Lagos', 282: 'Los Lagos', 307: 'Los Lagos', 308: 'Los Lagos',
    284: 'Aysén', 285: 'Aysén', 286: 'Aysén', 287: 'Aysén', 288: 'Aysén', 289: 'Aysén',
    309: 'Aysén', 310: 'Aysén', 311: 'Aysén', 312: 'Aysén',
    290: 'Magallanes', 291: 'Magallanes', 292: 'Magallanes', 313: 'Magallanes',
    314: 'Magallanes', 315: 'Magallanes', 316: 'Magallanes', 317: 'Magallanes',
    318: 'Magallanes', 319: 'Magallanes',
    293: 'Arica y Parinacota', 294: 'Arica y Parinacota', 295: 'Arica y Parinacota',
    296: 'Tarapacá', 297: 'Tarapacá', 347: 'Tarapacá',
    298: 'Antofagasta', 299: 'Antofagasta', 300: 'Antofagasta', 301: 'Antofagasta',
    302: 'Atacama'
};
